module.exports = __webpack_public_path__ + "img/VWFS-Fahrzeugschein-Beispiel.a00fb83a.png";